import { Decimal } from 'decimal.js';

// fix 3 * 0.1 = 0.30000000000000004
export function safeMul(x: number, y: number) {
	return Decimal.mul(x, y).toNumber();
}
